import React from "react";

// Must match app/helpers/outils_helper.rb (fc_max / fc_max_tanaka / FC_ZONES).
const DEFAULT_AGE = "30";
const ZONES = [
    { name: "Récupération", low: 0.5, high: 0.6, desc: "Échauffement, récupération active" },
    { name: "Endurance fondamentale", low: 0.6, high: 0.7, desc: "Brûlage des graisses, sorties longues" },
    { name: "Aérobie", low: 0.7, high: 0.8, desc: "Amélioration de l'endurance cardio" },
    { name: "Seuil anaérobie", low: 0.8, high: 0.9, desc: "Progression de la vitesse, tempo" },
    { name: "Effort maximal", low: 0.9, high: 1.0, desc: "VO2 max, fractionné court" },
];

const fcMax = (age) => 220 - age;
const fcMaxTanaka = (age) => Math.round(208 - 0.7 * age);

function zoneBpm(age, low, high, resting) {
    const max = fcMax(age);
    if (resting > 0) {
        const reserve = max - resting;
        return [Math.round(reserve * low + resting), Math.round(reserve * high + resting)];
    }
    return [Math.round(max * low), Math.round(max * high)];
}

export default function App() {
    const [age, setAge] = React.useState(DEFAULT_AGE);
    const [resting, setResting] = React.useState("");

    const ageNum = parseInt(age, 10);
    const restingNum = parseInt(resting, 10) || 0;
    const valid = ageNum > 0 && ageNum < 120;

    const max = valid ? fcMax(ageNum) : null;
    const tanaka = valid ? fcMaxTanaka(ageNum) : null;

    return (
        <>
            <div className="p-4 my-2 sm:my-4 bg-stone-100 rounded-lg flex flex-wrap gap-6">
                <div>
                    <label htmlFor="fc-age" className="text-sm sm:text-base mb-2 block cursor-default">Votre âge</label>
                    <div className="flex items-center gap-2">
                        <input
                            id="fc-age"
                            type="text"
                            inputMode="numeric"
                            className="py-2 w-16 sm:w-24 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300"
                            value={age}
                            onChange={(e) => setAge(e.target.value.replace(/[^0-9]/g, ""))}
                        />
                        <span className="text-base sm:text-xl font-bold cursor-default">ans</span>
                    </div>
                </div>
                <div>
                    <label htmlFor="fc-repos" className="text-sm sm:text-base mb-2 block cursor-default">
                        FC au repos <span className="font-normal text-gray-500">(optionnel)</span>
                    </label>
                    <div className="flex items-center gap-2">
                        <input
                            id="fc-repos"
                            type="text"
                            inputMode="numeric"
                            placeholder="—"
                            className="py-2 w-16 sm:w-24 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300"
                            value={resting}
                            onChange={(e) => setResting(e.target.value.replace(/[^0-9]/g, ""))}
                        />
                        <span className="text-base sm:text-xl font-bold cursor-default">bpm</span>
                    </div>
                </div>
            </div>

            {valid && (
                <>
                    <div className="p-4 my-2 sm:my-4 rounded-lg w-full bg-gradient-to-b from-pink-900 to-pink-700 text-white text-center">
                        <div className="text-sm text-pink-200">Fréquence cardiaque maximale</div>
                        <div className="text-4xl sm:text-5xl font-bold my-1">{max} <span className="text-xl font-semibold">bpm</span></div>
                        <div className="text-xs text-pink-100">Formule 220 − âge · Méthode de Tanaka : {tanaka} bpm</div>
                    </div>

                    <div className="mb-2 font-bold text-center w-full sm:text-lg cursor-default">
                        Vos 5 zones d'entraînement{restingNum > 0 ? " (méthode de Karvonen)" : ""}
                    </div>
                    <div className="flex flex-col gap-2">
                        {ZONES.map((z, i) => {
                            const [lo, hi] = zoneBpm(ageNum, z.low, z.high, restingNum);
                            return (
                                <div key={i} className="flex items-center justify-between gap-3 bg-stone-100 rounded-lg px-4 py-2">
                                    <div>
                                        <div className="font-semibold text-sm sm:text-base text-gray-900">Zone {i + 1} · {z.name}</div>
                                        <div className="text-xs text-gray-600">{z.desc}</div>
                                    </div>
                                    <div className="text-right shrink-0">
                                        <div className="font-bold text-base sm:text-lg text-pink-800">{lo}–{hi}</div>
                                        <div className="text-xs text-gray-500">{Math.round(z.low * 100)}–{Math.round(z.high * 100)} %</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </>
            )}
        </>
    );
}
